var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini","circle":""},on:{"click":_vm.logout}},[_c('i',{staticClass:"icon iconfont icon-logout"})])
}
var staticRenderFns = []

export { render, staticRenderFns }